"use client";
import Image from "next/image";
import { useState, useEffect } from "react";

export default function ImageWithFallback({
  src,
  alt = "",
  fallbackSrc,
  ...props
}) {
  const defaultFallback = "/assets/fallbacks/blogFallback.webp";
  const [currentSrc, setCurrentSrc] = useState(
    src || fallbackSrc || defaultFallback
  );

  useEffect(() => {
    setCurrentSrc(src || fallbackSrc || defaultFallback);
  }, [src, fallbackSrc]);

  const handleError = () => {
    const fb = fallbackSrc || defaultFallback;
    if (currentSrc !== fb) setCurrentSrc(fb);
  };

  return <Image {...props} src={currentSrc} alt={alt} onError={handleError} />;
}
